import { consoleLog } from './consoleLog.ts'

consoleLog("Welcome to HvS consulting theme!")
